import type { ReactNode } from 'react'
import type { Components } from 'react-markdown'
import ReactMarkdown from 'react-markdown'
import remarkDirective from 'remark-directive'
import remarkGfm from 'remark-gfm'
import type { NewsArticle } from '../../../Model/News/newsArticle.js'
import { NewsArticleContext, NewsDirective } from './newsDirectives.js'
import { DIRECTIVE_TAG, readDirectiveProps, remarkNewsDirectives } from './remarkNewsDirectives.js'

const REMARK_PLUGINS = [remarkGfm, remarkDirective, remarkNewsDirectives]

type HastNode = { type: string; value?: string; children?: HastNode[] }

const textOf = (node?: HastNode): string => (node?.type === 'text' ? (node.value ?? '') : (node?.children ?? []).map(textOf).join(''))

export const headingId = (text: string) =>
  text
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-|-$/g, '')

const Heading2 = ({ node, children }: { node?: HastNode; children?: ReactNode }) => (
  <h2 id={headingId(textOf(node))} className="scroll-mt-24">
    {children}
  </h2>
)

const COMPONENTS = {
  h2: Heading2,
  [DIRECTIVE_TAG]: ({ directive, children }: { directive: unknown; children?: ReactNode }) => (
    <NewsDirective {...readDirectiveProps(directive)}>{children}</NewsDirective>
  )
} as unknown as Components

export const NewsMarkdown = ({ article }: { article: Pick<NewsArticle, 'dir' | 'hero' | 'body'> }) => (
  <NewsArticleContext.Provider value={article}>
    <ReactMarkdown remarkPlugins={REMARK_PLUGINS} components={COMPONENTS}>
      {article.body}
    </ReactMarkdown>
  </NewsArticleContext.Provider>
)
